"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStakingAccountInstruction = void 0;
const utils_1 = require("../utils");
/**
 * Returns an instruction which creates a Staking Account to hold a user's staked token information
 *
 * @param connection
 * @param user - Public key of user creating the staking account
 * @param registeredStake - Public key of `RegisteredStake` which this staking account corresponds to
 * @param programId - Deployed program ID for Staking program
 */
function createStakingAccountInstruction({ connection, user, registeredStake, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getStakingProgram)({ connection, programId });
        const ixSet = {
            instructions: [],
            signers: [],
        };
        const ix = yield program.methods
            .createStakingAccount()
            .accounts({
            user,
            registeredStake,
        })
            .instruction();
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.createStakingAccountInstruction = createStakingAccountInstruction;
//# sourceMappingURL=createStakeAccount.js.map